<div class="split left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/automapai-logo.png" class="header-termhub-logo" alt="AutomapAI" />
      </div>
    </div>
  </header>

  <div class="signup-body">
    <div>
      <span class="header-text">Sign Up</span>
    </div>
    <div class="input-text-font">
      Thank you for your interest in the AutomapAI reference platform. Please provide your contact info and submit the form below. Our service team
      will reach out with account details shortly.
    </div>
    <div class="login-box">
      <div class="login-form mt-3">
        <div>
          <app-input
            [for]="'usernameInputFC'"
            label="Name"
            placeholder="Enter your name, .e.g. Jane Smith"
            type="text"
            [control]="nameFC"
            [required]="true"
            (keydown.enter)="onSubmit()"
          ></app-input>
          <app-input
            [for]="'userEmailInputFC'"
            label="Email"
            placeholder="Enter your email"
            type="email"
            [control]="emailFC"
            [required]="true"
            (keydown.enter)="onSubmit()"
          ></app-input>
          <div class="input-container h-fit-content">
            <div class="view-password">
              <app-input
                [for]="'passwordInputFC'"
                *ngIf="!show_eye"
                label="Password"
                placeholder="Enter a password"
                type="password"
                [control]="passwordFC"
                [required]="true"
                (keydown.enter)="onSubmit()"
              ></app-input>
              <app-input
                [for]="'passwordInputFC'"
                *ngIf="show_eye"
                label="Password"
                placeholder="Enter a password"
                type="text"
                [control]="passwordFC"
                [required]="true"
                (keydown.enter)="onSubmit()"
              ></app-input>
              <div *ngIf="show_eye" class="show-hide-eye default-pointer" (click)="showPassword(false)">
                <i class="fa-solid fa-eye svg-inline-auth m-t-3"> </i>
              </div>
              <div *ngIf="!show_eye" class="show-hide-eye default-pointer" (click)="showPassword(true)">
                <i class="fa-solid fa-eye-slash svg-inline-auth m-t-3"> </i>
              </div>
            </div>
          </div>

          <div *ngIf="email_error" class="mb-3">
            <div class="is-invalid">{{ emailErrorMessage }}</div>
            <span [hidden]="!email_error">
              Would you like to <a class="form-link" [routerLink]="'/login'">Log In</a>? or
              <a class="form-link" [routerLink]="'/password-reset'">Reset your password</a>?
            </span>
          </div>
          <div *ngIf="email_verified_error" class="mb-3">
            <div class="is-invalid">{{ emailErrorMessage }}</div>
          </div>
        </div>
        <div class="form-group">
          <app-input
            [for]="'orgInputFC'"
            class="org-input"
            label="Organization"
            placeholder="Enter organization"
            type="text"
            [control]="organizationFC"
            [required]="true"
            (keydown.enter)="onSubmit()"
          ></app-input>
          <div class="signup-check mt-3">
            <input type="checkbox" [(ngModel)]="termsAndPrivacy" /> I accept our
            <a class="form-link" href="https://www.terminologyhub.com/terms-of-service" target="_blank"> Terms of Service </a> and
            <a class="form-link" href="https://www.terminologyhub.com/privacy-policy" target="_blank"> Privacy Policy</a>
          </div>
          <div class="form-group">
            <app-button
              for="signupButton"
              btnType="login"
              type="submit"
              [disabled]="!termsAndPrivacy || email_error || !emailFC.value || !nameFC.value || !organizationFC.value || !passwordFC.value"
              (click)="onSubmit()"
              >Sign Up</app-button
            >

            <div class="is-invalid">{{ submitMessage }}</div>
          </div>
        </div>
        <div class="new-account mt-3">
          <div class="signup-link">
            <div>Already have an account? <a class="form-link" [routerLink]="'/login'">Log In ></a></div>
          </div>
        </div>
      </div>

      <ng-template #resultModal let-modal>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeBtn">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>{{ submitMessage }}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="modal.close('OK')" id="okBtn">OK</button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="split right tinted-image"></div>
  </div>
</div>
